/* eslint-disable import/prefer-default-export */
import type * as Actions from '@src/redux/actions/privileges.actions'
import * as ActionTypes from '@src/redux/actionTypes'
import { defaultState } from './default.state'

export function reducer(state = defaultState, action: Actions.ActionTypes) {
  switch (action.type) {
    case ActionTypes.Privileges.GET_STAT_SUCCESS: {
      return {
        ...state,
        [action.payload.stat]: action.payload.value,
        isPending: false
      }
    }

    case ActionTypes.Privileges.GET_OVERVIEW_STATS_DATA: {
      return {
        ...state,
        privilegesList: action.payload.list,
        isPending: false
      }
    }

    case ActionTypes.Privileges.SERVER_ERRORS: {
      return {
        ...state,
        errors: action.payload.errors
      }
    }

    case ActionTypes.Privileges.REQUEST_PENDING: {
      return {
        ...state,
        isPending: action.payload.isPending
      }
    }

    default: {
      return state
    }
  }
}
